import * as React from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

export function CompetitionAnalyzerReportExecutionProvider({children}) {
	const { state, updateState, resetState } = useAppContextState({ idReportExecution: null })

	return <Context.Provider value={{state, updateState, resetState}}>
		{children}
	</Context.Provider>
}

export default Context
